import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("IndicatorSummaryPermissions")
export class IndicatorSummaryPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Upload = 2;
}
